const SECONDS_TIMESTAMP_MS_THRESHOLD = 10000000000;
const MILLISECONDS_PER_SECOND = 1000;

const DATE_UNAVAILABLE_LABEL = 'Date unavailable';
const TIME_UNAVAILABLE_LABEL = 'Time unavailable';

const isValidDate = (date: Date): boolean => !Number.isNaN(date.getTime());

export const timestampToDate = (timestamp: number): Date => {
  if (!Number.isFinite(timestamp) || timestamp <= 0) {
    return new Date(NaN);
  }
  const timestampInMs =
    timestamp < SECONDS_TIMESTAMP_MS_THRESHOLD ? timestamp * MILLISECONDS_PER_SECOND : timestamp;
  return new Date(timestampInMs);
};

export const formatDate = (date: Date | number): string => {
  const d = typeof date === 'number' ? new Date(date) : date;
  if (!isValidDate(d)) return DATE_UNAVAILABLE_LABEL;
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(d);
};

export const formatTime = (date: Date | number): string => {
  const d = typeof date === 'number' ? new Date(date) : date;
  if (!isValidDate(d)) return TIME_UNAVAILABLE_LABEL;
  return new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(d);
};

export const formatFullDate = (date: Date | number): string => {
  const d = typeof date === 'number' ? new Date(date) : date;
  if (!isValidDate(d)) return DATE_UNAVAILABLE_LABEL;
  return new Intl.DateTimeFormat('en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(d);
};

export const formatDateAndTime = (date: Date | number): { date: string; time: string } => {
  const d = typeof date === 'number' ? new Date(date) : date;
  if (!isValidDate(d)) return { date: DATE_UNAVAILABLE_LABEL, time: '' };
  return {
    date: new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }).format(d),
    time: formatTime(d),
  };
};

export const formatShortDate = (date: Date | string | number): string => {
  const d = new Date(date);
  if (!isValidDate(d)) return DATE_UNAVAILABLE_LABEL;
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  });
};
